import React from "react";
import { Container } from "react-bootstrap";
import "./Second.css";
import first from "../../../../Asset/logistic-card-1.png";
import second from "../../../../Asset/logistic-card-2.png";
import third from "../../../../Asset/logistic-card-3.png";
import fourth from "../../../../Asset/logistic-card-4.png";

const Second = () => {
  return (
    <>
      <section className="second-logistic-section">
        <Container>
          <div className="top-text-after-fourth-services">
            <h2>
              INDUSTRIES WE ARE <span>DELIGHTED TO SERVE</span>
            </h2>
          </div>
          <div className="sucess_cards_warp">
            <div className="row sucess_row">
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 cards_main">
                <div className="card_inner">
                  <div className="image_part">
                    <img src={first} alt="card" className="w-100" />
                  </div>
                  <div className="contant_part">
                    <h3>Advanced-Data Analytics</h3>
                    <p>
                      Harness the power of big data to optimize routes, predict
                      demand, and improve decision-making.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 cards_main">
                <div className="card_inner">
                  <div className="image_part">
                    <img src={second} alt="card" className="w-100" />
                  </div>
                  <div className="contant_part">
                    <h3>Cloud-Based Integration </h3>
                    <p>
                      Seamlessly connect all aspects of your logistics chain
                      with our cloud-based solutions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 cards_main">
                <div className="card_inner">
                  <div className="image_part">
                    <img src={third} alt="card" className="w-100" />
                  </div>
                  <div className="contant_part">
                    <h3>Tailored IT Infrastructure</h3>
                    <p>
                      Custom-design your IT infrastructure to meet the unique
                      demands of your logistics operations.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 cards_main">
                <div className="card_inner">
                  <div className="image_part">
                    <img src={fourth} alt="card" className="w-100" />
                  </div>
                  <div className="contant_part">
                    <h3>Cybersecurity for Logistics</h3>
                    <p>
                      Protect your sensitive shipping data and ensure compliance
                      with industry regulations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
